/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_NameInputs */

const en_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OFFSHORELABS`)
};

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const ar_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const he_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const ur_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const es_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const fr_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const de_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const pt_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const hi_app_name = en_app_name;

/** @type {(inputs: App_NameInputs) => LocalizedString} */
const bn_app_name = en_app_name;

/**
* | output |
* | --- |
* | "OFFSHORELABS" |
*
* @param {App_NameInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const app_name = /** @type {((inputs?: App_NameInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_NameInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_app_name(inputs)
	if (locale === "he") return he_app_name(inputs)
	if (locale === "ur") return ur_app_name(inputs)
	if (locale === "es") return es_app_name(inputs)
	if (locale === "fr") return fr_app_name(inputs)
	if (locale === "de") return de_app_name(inputs)
	if (locale === "pt") return pt_app_name(inputs)
	if (locale === "hi") return hi_app_name(inputs)
	if (locale === "bn") return bn_app_name(inputs)
	return /** @type {LocalizedString} */ ("OFFSHORELABS")
});